import React from "react";
import ServicesGrid from "@/components/ServicesGrid";
import ProblemSelector from "@/components/ProblemSelector";
import { useLanguage } from "@/context/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServicesPage() {
  const { t } = useLanguage();
  return (
    <div data-testid="services-page">
      <section className="pt-20 pb-12 bg-brand-bg">
        <div className="container-pad max-w-3xl">
          <div className="overline">{t.services.overline}</div>
          <h1 className="mt-4 font-serif text-5xl sm:text-6xl leading-[1] text-brand-primary">
            {t.services.title}
          </h1>
          <p className="mt-6 text-lg text-brand-text/75 leading-relaxed">
            {t.services.subtitle}
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-primary text-brand-surface px-7 py-3.5 text-sm font-semibold hover:bg-brand-secondary transition-colors"
            data-testid="services-page-cta"
          >
            {t.nav.cta}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      <ServicesGrid withImages compact />
      <ProblemSelector />
    </div>
  );
}
